import moment from "moment";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import Typography from "../../common/Typography";

interface Props {
  data: any;
}

function PlanBadge(props: Props) {
  const { data } = props;

  if (data?.myPlans && data?.myPlans[0]?.title === data?.name) {
    return (
      <>
        <Typography
          component={"span"}
          variant={"label"}
          changeVariant={false}
          sx={{
            marginBottom: "4px",
            "&::before": {
              content: '""',
              display: "inline-block",
              height: "8px",
              width: "8px",
              borderRadius: "100%",
              backgroundColor: "#799CB6", //TODO: replace with token
              marginRight: "4px"
            }
          }}
        >
          Plan Added
        </Typography>
      </>
    );
  }

  if (data?.dueDate) {
    let date = new Date();
    let yesterday = date.setDate(date.getDate() - 1);
    const isOverdue = moment(data?.dueDate).isBefore(moment(yesterday));
    return (
      <>
        <Typography
          variant={"label"}
          changeVariant={false}
          color={isOverdue ? tokens.Text.Feedback.OverdueLight : tokens.Text.General.Tertiary}
          showBold
          sx={{
            marginBottom: "4px",
            "&::before": {
              content: '""',
              display: "inline-block",
              height: "8px",
              width: "8px",
              borderRadius: "100%",
              backgroundColor: isOverdue ? tokens.Text.Feedback.OverdueLight : tokens.Text.General.Tertiary,
              marginRight: "4px"
            }
          }}
        >
          {isOverdue ? "Overdue" : "Duedate"}
          <Typography variant="label" changeVariant={false}>
            {isOverdue ? " since" : ""}
            {` ${getUIFormatDate(data?.dueDate)}`}
          </Typography>
        </Typography>
      </>
    );
  }
  return null;
}
export default PlanBadge;
